import { ChangeEvent } from 'react';
import { ProductsToPickup } from 'pages/picking-management/types';
import { Checkbox, Text } from 'components';
import { FontSize, FontWeight, TEST_IDS } from 'commons';
import * as S from './styles';

interface Props {
  product: ProductsToPickup;
  isChecked: boolean;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export function ProductCard({
  product,
  isChecked,
  handleChange,
}: Props): JSX.Element {
  const { legacySKU, name, image, consignmentCode, quantity } = product;

  return (
    <S.Wrapper $checked={isChecked} data-testid={TEST_IDS.PRODUCT_CARD_WRAPPER}>
      <S.HiddenCheckbox
        type="checkbox"
        name={`${consignmentCode}/${legacySKU}`}
        id={`${consignmentCode}/${legacySKU}`}
        checked={isChecked}
        onChange={handleChange}
      />
      <Checkbox
        name={`${consignmentCode}/${legacySKU}`}
        id={`${consignmentCode}/${legacySKU}`}
        checked={isChecked}
        readOnly
      />
      <S.Content>
        <S.ImageWrapper>
          <img src={image} alt={name} />
        </S.ImageWrapper>
        <S.TextWrapper>
          <Text weight={FontWeight.bold}>{legacySKU}</Text>
          <Text size={FontSize.font12}>{name}</Text>
          <Text size={FontSize.font12}>
            <strong>Quant.: {quantity}</strong>
          </Text>
          <Text size={FontSize.font12}>{consignmentCode}</Text>
        </S.TextWrapper>
      </S.Content>
    </S.Wrapper>
  );
}
